module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fBBc4.020c97dc.woff2";